// Note about using this class
// there are likely better ways to get this functionality for your use case
// various React libraries have request deduplication built-in
// however, this is necessary for deduplicating requests made through the
// Twilio SDK because we are using the library to make requests, and are not
// making raw http requests.

export class RequestDeduper<T> { 
  previousRequest: Promise<T> | null;
  fetchFn: () => Promise<T>;

  constructor(fetchFn: () => Promise<T>) {
    this.fetchFn = fetchFn;
  }

  async call(): Promise<T> {
    if(!this.previousRequest || await this.isRequestComplete(this.previousRequest)) {
      this.previousRequest = this.fetchFn();
      return this.previousRequest;
    } else {
      return this.previousRequest;
    }
  }

  // implementation based on
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/race#using_promise.race_to_detect_the_status_of_a_promise
  async isRequestComplete(
    request: Promise<T>
  ): Promise<boolean> {
    const pendingState = { status: "pending" };

    return Promise.race([request, pendingState]).then(
      (value) => {
        return value !== pendingState;
      },
      (reason) => true,
    );
  };
}
